import { render, staticRenderFns } from "./TextBodyLarge.vue?vue&type=template&id=470b3ac4&scoped=true"
import script from "./TextBodyLarge.vue?vue&type=script&lang=js"
export * from "./TextBodyLarge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470b3ac4",
  null
  
)

export default component.exports